<div class="courthouse-selector-wrapper">
  <div 
    class="courthouse-trigger" 
    [class.disabled]="disabled"
    [class.focused]="isOpen"
    (click)="togglePanel($event)"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    tabindex="0"
    (keydown.enter)="togglePanel($event)"
    (keydown.space)="togglePanel($event); $event.preventDefault()">
    <span class="trigger-label">{{ label }}</span>
    <span class="trigger-text">{{ triggerText }}</span>
    <span class="trigger-icon material-icons">arrow_drop_down</span>
  </div>
  <span class="trigger-hint">{{ hint }} <ng-content></ng-content></span>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    (overlayOutsideClick)="closePanel(); $event.stopPropagation()">
    <div class="courthouse-panel ee__standard-shadow">
      @if (courts.length > 0) {
        @for (court of courts; track court.id) {
          <div
            class="courthouse-card"
            [class.selected]="isSelected(court)"
            (click)="toggleSelection(court, $event)"
            role="option"
            [attr.aria-selected]="isSelected(court)"
            tabindex="0"
            (keydown.enter)="toggleSelection(court, $event)"
            (keydown.space)="toggleSelection(court, $event); $event.preventDefault()">

            <div class="court-type">{{ court.type }}</div>
            <div class="courthouse-name">{{ court.name }}</div>
            <div class="courthouse-address">{{ formatStreetAddress(court) }}</div>
            <div class="courthouse-city-state-zip">{{ formatCityStateZip(court) }}</div>
          </div>
        }
      } @else {
        <div class="no-courts">No courthouses available for selection.</div>
      }
    </div>
  </ng-template>
</div>
